module.exports = __webpack_public_path__ + "static/media/Grid.b5bdf083.svg";